import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  /**
   * 仓库管理
   */
  wareManageList: {},
  wareManageMark: 0,
  cityList: {},
  channelTypeList: [],
  warehousePay: {}
}

const actions = {
  /**
   * 仓库管理
   */
  // 仓库管理列表数据
  [types.WAREHOUSEGETPAGE] (context, params) {
    http.fetch('/api/warehouse/getPage', params).then(data => {
      context.commit(types.WAREHOUSEGETPAGE, data)
    })
  },
  // // 新增仓库
  // [types.WAREHOUSEADD] (context, params) {
  //   http.fetch('/api/warehouse/add', params).then(data => {
  //     context.commit(types.WAREHOUSEADD, data)
  //   })
  // },
  // 更新仓库
  [types.WAREHOUSEUPDATA] (context, params) {
    http.fetch('/api/warehouse/update', params).then(data => {
      context.commit(types.WAREHOUSEUPDATA, data)
    })
  },
  // 获取仓库支付配置 - zsh
  [types.GETWAREHOUSEPAY] (context, params) {
    http.fetch('/api/warehousePay/getOne', params).then(data => {
      context.commit(types.GETWAREHOUSEPAY, data)
    })
  },
  // 更新仓库支付配置 - zsh
  [types.WAREHOUSEPAYUPDATA] (context, params) {
    http.fetch('/api/warehousePay/update', params).then(data => {
      context.commit(types.WAREHOUSEPAYUPDATA, data)
    })
  },
  // 重置密码
  [types.WAREHOUSERESET] (context, params) {
    http.fetch('/api/warehouse/resetPwd', params).then(data => {
      context.commit(types.WAREHOUSERESET, data)
    })
  },
  // 获取地区列表
  [types.GETCITY] (context, params) {
    let type = params.type || null
    http.fetch('/api/city/getCity', params).then(data => {
      context.commit(types.GETCITY, { ...data, type })
    })
  },
  // 获取渠道列表
  [types.GETCHANNELTYPE] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.GETCHANNELTYPE, data)
    })
  }
}

const mutations = {
  /**
   * 仓库管理
   */
  // 仓库管理列表数据
  [types.WAREHOUSEGETPAGE] (state, data) {
    data.rows.forEach(item => {
      item.region = item.region.split(',')
    })
    state.wareManageList = data
  },
  // 新增仓库
  // [types.WAREHOUSEADD] (state, data) {
  //   if (data.code === 200) {
  //     state.wareManageMark = 1
  //     vue.$message({
  //       showClose: true,
  //       message: '新增成功',
  //       type: 'success'
  //     })
  //   }
  // },
  // 编辑仓库
  [types.WAREHOUSEUPDATA] (state, data) {
    if (data.code === 200) {
      state.wareManageMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    }
  },
  // 仓库支付配置数据
  [types.GETWAREHOUSEPAY] (state, data) {
    console.log('aah', data)
    state.warehousePay = data
    return data
  },
  // 编辑仓库支付配置
  [types.WAREHOUSEPAYUPDATA] (state, data) {
    if (data.code === 200) {
      state.wareManageMark = 1
      vue.$message({
        showClose: true,
        message: '编辑成功',
        type: 'success'
      })
    }
  },
  // 重置密码
  [types.WAREHOUSERESET] (state, data) {
    if (data.code === 200) {
      state.wareManageMark = 1
      vue.$confirm('重置密码成功', '成功', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'warning'
      })
    }
  },
  // 获取地区列表
  [types.GETCITY] (state, data) {
    data.obj.forEach((item, index) => {
      item.value = item.code
      item.label = item.name
      switch (item.level) {
        case 1:
          // 省
          if (data.type && data.type !== item.code) {
            item.disabled = true
          }
          item.leaf = false
          break
        case 2:
          // 市
          item.leaf = false
          break
        default:
          // 区
          if (item.label === '市辖区') {
            item.disabled = true
          }
          item.leaf = true
          break
      }
    })
    state.cityList = data.obj
    console.log(data, '获取地区列表')
  },
  // 获取渠道列表
  [types.GETCHANNELTYPE] (state, data) {
    if (data.code === 200) {
      state.channelTypeList = data.obj
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/wareManage/index.js